import React, { useEffect, useState } from "react";
import CardDiv from "modules/common/card-div/CardDiv";
import AssignedOrderFilter from "modules/dashboards/actionables/AssignedOrderFilter";
import { Button } from "react-bootstrap";
import {
  useAllOrderStore,
  useOpenOrdersStore,
} from "modules/order_management/store";
import { useLocation, useNavigate } from "react-router-dom";
import { useToast } from "modules/navbar/top/store/toasterStore";
import PaginationDiv from "modules/pagination/PaginationDiv";
import OpenOrdersTable from "modules/order_management/OpenOrdersTable";
import { isDownloadDisabled } from "modules/utilities/utility";

function OpenOrders() {
  const {
    openOrderData,
    openOrdersLoading,
    downloading,
    fetchOpenOrdersData,
    getOpenOrdersDownload,
  } = useOpenOrdersStore();
  const {
    medicalData,
    consultData,
    operationData,
    fetchMedicalRep,
    fetchConsultRep,
    fetchOperations,
  } = useAllOrderStore();
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const [queryParams, setQueryParams] = useState("");
  const [page, newPage] = useState(1);
  const { setToaster } = useToast();
  const pageData = searchParams.get("pageNumber");
  const startDate = searchParams.get("startDate");
  const endDate = searchParams.get("endDate");
  const bulk = searchParams.get("isBulk");
  const subscription = searchParams.get("isSubscription");
  const status = searchParams.get("status");
  const subStatus = searchParams.get("subStatus");
  const doctor = searchParams.get("doctors");
  const orderSource = searchParams.get("orderSource");
  const owner = searchParams.get("assignedTo");
  const repeat = searchParams.get("orderType");
  const orderType = searchParams.get("orderSourceType");
  const combo = searchParams.get("isCombo");
  const [pageFlag, setPageFlag] = useState(false);

  useEffect(() => {
    const queryParamsMap = {
      startDate: startDate && `&startDate=${startDate}`,
      endDate: endDate && `&endDate=${endDate}`,
      isBulk: bulk && `&isBulk=${bulk}`,
      isSubscription: subscription && `&isSubscription=${subscription}`,
      status: status && `&status=${status}`,
      subStatus: subStatus && `&subStatus=${subStatus}`,
      doctors: doctor && `&doctors=${doctor}`,
      orderSource: orderSource && `&orderSource=${orderSource}`,
      orderType: repeat && `&orderType=${repeat}`,
      assignedTo: owner && `&assignedTo=${owner}`,
      orderSourceType: orderType && `&orderSourceType=${orderType}`,
      isCombo: combo && `&isCombo=${combo}`,
    };
    const queryParams = Object.values(queryParamsMap).filter(Boolean).join("");
    setQueryParams(queryParams);
  }, [
    startDate,
    endDate,
    bulk,
    subscription,
    status,
    subStatus,
    doctor,
    orderSource,
    orderType,
    owner,
    orderType,
    combo,
  ]);

  useEffect(() => {
    newPage(Number(pageData));
  }, []);

  useEffect(() => {
    fetchMedicalRep();
    fetchConsultRep();
    fetchOperations();
  }, []);

  useEffect(() => {
    setPageFlag(true);
    if(pageFlag){
      if (queryParams) {
        navigate(
          `/order-management/open_orders?${queryParams}&pageNumber=${page}`
        );
      } else {
        navigate(`/order-management/open_orders?pageNumber=${page}`);
      }
    }
  }, [page, queryParams]);

  useEffect(() => {
    const queryParamsMap = {
      startDate: startDate && `&startDate=${startDate}`,
      endDate: endDate && `&endDate=${endDate}`,
      isBulk: bulk && `&isBulk=${bulk}`,
      isSubscription: subscription && `&isSubscription=${subscription}`,
      status: status && `&status=${status}`,
      subStatus: subStatus && `&subStatus=${subStatus}`,
      doctors: doctor && `&doctors=${doctor}`,
      orderSource: orderSource && `&orderSource=${orderSource}`,
      orderType: repeat && `&orderType=${repeat}`,
      assignedTo: owner && `&assignedTo=${owner}`,
      orderSourceType: orderType && `&orderSourceType=${orderType}`,
      isCombo: combo && `&isCombo=${combo}`,
    };
    const queryParams = Object.values(queryParamsMap).filter(Boolean).join("");
    if (pageData) {
      fetchOpenOrdersData(`pageNumber=${pageData}${queryParams}`);
    }
  }, [pageData, queryParams]);

  const handleDownload = () => {
    getOpenOrdersDownload(`pageNumber=${pageData}${queryParams}`, setToaster);
  };

  return (
    <div>
      <CardDiv
        title={
          <>
            <div className="d-flex justify-content-between align-items-center">
              <div className="fs-2 text-black">Open Orders</div>
              <div className="d-flex gap-3 flex-row">
                <div>
                  <AssignedOrderFilter
                    medicalReps={medicalData}
                    consultReps={consultData}
                  />
                </div>
                <Button className="btn btn-primary" onClick={handleDownload} disabled = {isDownloadDisabled}>
                  Download
                </Button>
              </div>
            </div>
          </>
        }
        component={
          <div>
            <div>
              <div>
                <OpenOrdersTable
                  tableData={openOrderData?.data}
                  isLoading={openOrdersLoading}
                />
              </div>
              <PaginationDiv
                paginationData={{
                  pageCount: openOrderData?.pagination?.pageCount
                    ? openOrderData?.pagination?.pageCount
                    : 1,
                  page: page,
                }}
                newPage={newPage}
              />
            </div>
          </div>
        }
      />
    </div>
  );
}

export default OpenOrders;
